import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLargeUserAlt = function SvgLargeUserAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 68 68",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M34 14.9c2.3 0 4.3 1.9 4.3 4.3s-1.9 4.3-4.3 4.3c-2.3 0-4.3-1.9-4.3-4.3s2-4.3 4.3-4.3zm0-4.3c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5zM34 36.1c7 0 12.8 5.7 12.8 12.8 0 2.3-1.9 4.3-4.3 4.3h-17c-2.3 0-4.3-1.9-4.3-4.3.1-7 5.8-12.8 12.8-12.8zm0-4.2c-9.4 0-17 7.6-17 17 0 4.7 3.8 8.5 8.5 8.5h17c4.7 0 8.5-3.8 8.5-8.5 0-9.4-7.6-17-17-17z"
  }));
};

export default SvgLargeUserAlt;